"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _getSearchPreviewData = require("./getSearchPreviewData");
Object.keys(_getSearchPreviewData).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _getSearchPreviewData[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _getSearchPreviewData[key];
    }
  });
});
var _getTopAreaData = require("./getTopAreaData");
Object.keys(_getTopAreaData).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _getTopAreaData[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _getTopAreaData[key];
    }
  });
});
var _useGetCatalogues = require("./useGetCatalogues");
Object.keys(_useGetCatalogues).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useGetCatalogues[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useGetCatalogues[key];
    }
  });
});
var _useGetNavigationType = require("./useGetNavigationType");
Object.keys(_useGetNavigationType).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useGetNavigationType[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useGetNavigationType[key];
    }
  });
});
var _usePersonalBeautyStoreData = require("./usePersonalBeautyStoreData");
Object.keys(_usePersonalBeautyStoreData).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _usePersonalBeautyStoreData[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _usePersonalBeautyStoreData[key];
    }
  });
});